import React from 'react';
import {connect} from "react-redux";
import ButtonComponent from "../components/ButtonComponent";
import {withTranslation} from "react-i18next";
import ErrorComponent from "../components/ErrorComponent";

class OrderDownloadContainer extends React.Component {

	render() {
		return <div>
			{this.props.voucherError ? <ErrorComponent messageKey={this.props.voucherError === 'VOUCHERS_NOT_FOUND' ? 'reward.claim.vouchers.notFound' : 'error.global'}/>
				: this.props.error === null && <div data-tms-event="card-click-impression"
													data-tms-card-zone="myReward – deal download"
													data-tms-card-name="Download your deal">
					<ButtonComponent onButtonClick={() => {this.props.downloadVouchers(this.props.orderId, this.props.friendlyName)}}
																	textKey="reward.claim.vouchers.download"
																	downloading={this.props.downloading}
																	className="default-btn download-btn"/>
				</div>}
		</div>;
	}

}

export default withTranslation()(connect(
	(state) => {
		return {
			downloading: state.orderDetail.downloading,
			error: state.orderDetail.error,
			voucherError: state.orderDetail.voucherError,
			reward: state.reward.item,
			friendlyName: state.orderDetail.item === null ? null : state.orderDetail.item.rewardFriendlyName
		}
	},
	(dispatch) => {
		return {
			downloadVouchers: (orderId, friendlyName) => {
				dispatch({
					type: 'DOWNLOAD_VOUCHERS',
					orderId,
					friendlyName
				})
			}
		}
	}

) (OrderDownloadContainer))

